import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../../components/tabon/Logo";
import { api, formatError } from "../../lib/api";
import { useSAAuth } from "../../contexts/SAAuthContext";
import { toast } from "sonner";

export default function SALogin() {
  const navigate = useNavigate();
  const { setUser } = useSAAuth();
  const [email, setEmail] = useState("founder@tabon.app");
  const [password, setPassword] = useState("founder123");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/auth/login", { email, password });
      setUser(data);
      toast.success(`Welcome ${data.name}`);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen tb-hero-gradient flex items-center justify-center px-4">
      <div className="absolute inset-0 tb-grid-bg opacity-30 pointer-events-none" />
      <div className="relative w-full max-w-md tb-fade-up">
        <div className="flex flex-col items-center mb-8">
          <div className="flex items-center gap-2">
            <Logo size="xl" />
          </div>
          <span className="mt-3 text-[10px] font-bold uppercase tracking-wider bg-white/10 text-[#A0A0A0] border border-white/15 rounded-full px-3 py-1">
            Superadmin Portal
          </span>
        </div>
        <div className="bg-[#1A1A1A] border border-white/10 rounded-xl p-7 shadow-2xl">
          <h1 className="text-2xl font-bold mb-1">Internal Sign In</h1>
          <p className="text-sm text-[#A0A0A0] mb-6">TabOn founding team only</p>
          <form onSubmit={submit} className="flex flex-col gap-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-wider text-[#A0A0A0] mb-1.5 block">Email</label>
              <input
                data-testid="sa-login-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#0A0A0A] border border-white/10 rounded-lg px-4 py-3 min-h-[44px] text-white focus:border-[#9D00FF]"
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-wider text-[#A0A0A0] mb-1.5 block">Password</label>
              <input
                data-testid="sa-login-password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#0A0A0A] border border-white/10 rounded-lg px-4 py-3 min-h-[44px] text-white focus:border-[#9D00FF]"
              />
            </div>
            <button
              type="submit" disabled={loading} data-testid="sa-login-submit"
              className="tb-glow bg-[#9D00FF] hover:bg-[#8C00E6] disabled:opacity-60 text-white font-semibold rounded-lg py-3 min-h-[44px]"
            >
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
        <div className="text-center text-xs text-[#A0A0A0] mt-6">
          TabOn Superadmin · Internal Use Only · © 2026 TabOn
        </div>
      </div>
    </div>
  );
}
